import { render, staticRenderFns } from "./ItemBoxes.vue?vue&type=template&id=2f2eea54&"
import script from "./ItemBoxes.vue?vue&type=script&lang=js&"
export * from "./ItemBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports